"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const uuid_1 = require("uuid");
const mui_1 = require("tss-react/mui");
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const ListSubheader_1 = __importDefault(require("@mui/material/ListSubheader"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const utils_1 = require("companion-app-components/flux/preferences/utils");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('components/QuickenControls/AccountsMenu/index.tsx');
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const AccountsMenu = ({ selected, onChange, element, onClose, showColors, }) => {
    const [currentSelected, setCurrentSelected] = (0, react_1.useState)(selected);
    const accounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getTransactionAccounts(state));
    const { accountPreferencesById, datasetPreferences } = (0, useQPreferences_1.default)();
    const { classes } = useStyles();
    const options = (0, react_1.useMemo)(() => accounts.map((account) => {
        var _a;
        const color = (_a = accountPreferencesById[account.id]) === null || _a === void 0 ? void 0 : _a.color;
        return {
            color: (0, utils_1.colorLookup)(color),
            label: account.name,
            value: account.id,
        };
    }), [accounts, accountPreferencesById]);
    (0, react_1.useEffect)(() => {
        setCurrentSelected(selected);
    }, [selected]);
    const open = (element !== null);
    const isSelected = Boolean(selected);
    const handleRequestClose = () => {
        log.log('REQUEST CLOSE');
    };
    const keyDown = (e) => {
        if (e.key === 'Enter' ||
            e.key === 'ArrowUp' ||
            e.key === 'ArrowDown' ||
            e.key === 'Tab') {
            e.stopPropagation();
        }
        if (e.key === 'Escape') {
            if (onClose) {
                e.stopPropagation();
                onClose();
            }
        }
    };
    const onExited = () => {
        if (onClose) {
            onClose();
        }
    };
    const handleClick = (value) => {
        if (onChange) {
            onChange(value);
        }
    };
    const makeCheckListItem = (item, selectedFlag) => {
        const id = item.value;
        const { transactionRegister: regPrefs } = datasetPreferences;
        return (<ListItem_1.default dense button onClick={() => handleClick(id)} key={`qmenu_li_${item.value}`} disableGutters>
        {selectedFlag &&
                <ListItemIcon_1.default className={classes.listIcon}>
            <Check_1.default />
          </ListItemIcon_1.default>}
        {!selectedFlag &&
                <div className={classes.iconFiller}/>}

        {regPrefs.showAccountColors &&
                <div className={classes.colorBar} style={{ opacity: showColors ? 1 : 1, background: item.color }}/>}

        <ListItemText_1.default className={classes.listText} primary={item.label}/>
      </ListItem_1.default>);
    };
    const renderOptions = () => {
        const data = [];
        options.forEach((item) => {
            if (item.isDivider) {
                data.push(<Divider_1.default key={(0, uuid_1.v4)()}/>);
            }
            else if (item.isSubheader) {
                data.push(<ListSubheader_1.default key={`acctmenu_sub_${item.label}`}>
            <ListItemText_1.default className={classes.menuSubHead} secondary={item.label}/>
          </ListSubheader_1.default>);
            }
            else if (isSelected) {
                data.push(makeCheckListItem(item, currentSelected === item.value));
            }
            else {
                data.push(<MenuItem_1.default key={`acctmenu_li_${item.value}`} dense onClick={() => handleClick(item.value)} disableGutters>
            <ListItemText_1.default className={classes.listText} primary={item.label}/>
          </MenuItem_1.default>);
            }
        });
        return data;
    };
    return (<Menu_1.default id="long-menu" open={open} anchorEl={element} onClose={handleRequestClose} onKeyDown={keyDown} onBackdropClick={onClose || null} classes={{ paper: classes.menuRoot }} TransitionProps={{
            onExited,
        }}>
      {renderOptions()}
    </Menu_1.default>);
};
exports.default = AccountsMenu;
